const useSelectionStyle = (selected) => {
    return selected
        ? {
              border: `1px dashed var(--selected-node-border-color) !important`,
          }
        : {};
};

export default useSelectionStyle;
